import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const VipDealerRequestCtaWrapper = styled.div(
  ({ theme }) => `
  width: 100%;

  ${MEDIA_QUERIES(theme).medium} {
    flex: 1;
  }
`
)

export const VipDealerRequestCtaBanner = styled.div(
  ({ theme }) => `
  align-items: center;
  border-radius: ${theme.borderRadius.small};
  box-shadow: ${theme.boxShadow['shadow-2']};
  display: flex;
  gap: ${theme.spacing.default};
  justify-content: space-between;
  padding: ${theme.spacing.default};
  width: 100%;


  & img  {
    height: 7.2rem;
  }
`
)

export const VipDealerRequestCtaChevron = styled.div(
  ({ theme }) => `
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: ${theme.spacing.defaultSmall} 0 ${theme.spacing.defaultSmall} ${theme.spacing.default};
`
)
